import { BaseModel } from "@models/base.model";

export class PatientProblem extends BaseModel {
  PatientId: number;
  MedicalCodeId: number;
  Code: string = '';
  Description: string = '';
  FromDate: any;
  DisplayInList: boolean = true;
  RowOrder: number;
  ICDType: string = '';
  Problem: Array<PatientProblem> = new Array<PatientProblem>();
}

export class PatientProblemMaster extends BaseModel {
  MedicalCode: Array<any> = new Array<any>();
}

export class PatientFaceSheetViewModel {
  Entity = new PatientProblem();
  Masters = new PatientProblemMaster();
}
